<script>
  export let row = {};
</script>

<div class="group-badge" style="background-color: {row.color};">{row.groupname}</div>

<style lang="scss">
  .group-badge {
    border-radius: var(--border-radius-base);
    cursor: pointer;
    display: inline-flex;
    font-size: calc(var(--font-size-small) + 1px);
    margin: var(--margin-small);
    padding: var(--padding-small) var(--padding-base);
  }
</style>
